import React from 'react';

interface ITimer {
    isExpired: boolean;
    days: number
    minutes: number;
    seconds: number;
    hours: number;
}

const ShortDays = ({ isExpired, days, minutes, seconds, hours }: ITimer) => {
    return (
        <>
            {isExpired || (minutes === 0 && seconds === 0 && hours === 0 && days === 0) ?
                <></>
                :
                <>
                    { days > 0 &&
                        <>
                            {(days).toString()} {days === 1 ? 'Day' : 'Days'}
                        </>
                    }
                    { days === 0 &&
                        <>
                            <span className="">Ends Today</span>
                        </>
                    }

                </>
            }
        </>
    )
};

export default ShortDays;